import React from 'react';
import PropTypes from 'prop-types';

/**
 * Text component for consistent typography
 */
const Text = ({ 
  children,
  variant = 'body',
  className = '',
  as: Component = 'p',
  ...props 
}) => {
  const variantClasses = {
    h1: "text-4xl font-bold text-gray-900",
    h2: "text-3xl font-bold text-gray-900",
    h3: "text-2xl font-bold text-gray-900",
    h4: "text-xl font-semibold text-gray-900",
    body: "text-base text-gray-600",
    small: "text-sm text-gray-500"
  };

  return (
    <Component 
      className={`${variantClasses[variant]} ${className}`}
      {...props}
    >
      {children}
    </Component>
  );
};

Text.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'body', 'small']),
  className: PropTypes.string,
  as: PropTypes.elementType
};

export default Text;
